module.exports = __webpack_public_path__ + "static/Montserrat-SemiBold-c641dbee1d75892e4d88bdc31560c91b.ttf";